import {
  ErrorBoundary,
  ENVIRONMENTS,
  buildThemePath,
  getEnvironmentVariableByName,
  rootStore,
} from "@ob/core";
import {
  DEFAULT_LANGUAGE,
  defaultTheme,
  localeConfigurations,
  messages,
} from "./globalConfig";

import { IntlProvider } from "@ob/i18n";
import { ThemeProvider } from "@ob/theme";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import pkg from "../package.json";
import { AppRoutes } from "./appRoutes";
import "./assets/fontIcons/icons.css";
import "./assets/fonts/fonts.css";
import { FeedbackPage } from "./pages/FeedbackPage";

const APP_NAME = pkg.name;
const APP_VERSION = pkg.version;

const urlParams = new URLSearchParams(window.location.search);
const queryTestCondition = "mirage";

const REMOTE_THEME_ENABLED = getEnvironmentVariableByName(
  "REMOTE_THEME_ENABLED",
);
const API_ONBOARDING_KEY_NAME = getEnvironmentVariableByName(
  "API_ONBOARDING_KEY_NAME",
);
const API_ONBOARDING_KEY_VALUE = getEnvironmentVariableByName(
  "API_ONBOARDING_KEY_VALUE",
);
const remoteThemeConfig =
  REMOTE_THEME_ENABLED !== "true"
    ? undefined
    : {
        url: buildThemePath(urlParams?.get("ctheme")),
        headers: {
          [API_ONBOARDING_KEY_NAME]: API_ONBOARDING_KEY_VALUE,
        },
      };

const ENV = window.getEnv();
const shouldMockServer =
  ENV === ENVIRONMENTS.LOCAL &&
  urlParams.get(queryTestCondition)?.toLowerCase() === "true";

if (shouldMockServer) {
  import("./server").then(({ makeFakeServer }) => {
    makeFakeServer();
  });
}

if (ENV !== ENVIRONMENTS.PRODUCTION) {
  console.log(`${APP_NAME} release number: ${APP_VERSION}`);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <IntlProvider
    intlConfig={localeConfigurations}
    defaultLanguage={DEFAULT_LANGUAGE}
    messages={messages as never}
  >
    <ErrorBoundary fallback={<FeedbackPage />}>
      <Provider store={rootStore}>
        <ThemeProvider theme={defaultTheme} remoteConfig={remoteThemeConfig}>
          <AppRoutes appVersion={APP_VERSION} appName={APP_NAME} />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  </IntlProvider>,
);
